<div class="copy-link-dialog">
  <div class="title">{{ 'importItemDialog.header' | translate }}</div>
  <div class="copy-link-dialog-wrapper">
    <mat-radio-group [(ngModel)]="createCopy" class="radio-group">
      <mat-radio-button
        value="link"
        color="primary"
        class="radio-button"
        labelPosition="before"
        data-cy="link"
      >
        <div class="mat-caption">
          {{ data.link.title | translate }}
        </div>
        <div class="mat-description">
          {{ data.link.text | translate }}
        </div>
      </mat-radio-button>
      <mat-radio-button
        value="copy"
        color="primary"
        class="radio-button"
        labelPosition="before"
      >
        <div class="mat-caption">
          {{ data.copy.title | translate }}
        </div>
        <div class="mat-description">
          {{ data.copy.text | translate }}
        </div>
      </mat-radio-button>
    </mat-radio-group>
    <mat-dialog-actions class="footer">
      <qa-button
        [mat-dialog-close]="null"
        label="common.button.cancel"
      ></qa-button>
      <qa-button
        [isRaisedButton]="true"
        [mat-dialog-close]="createCopy"
        label="common.button.continue"
        data-cy="continue"
      ></qa-button>
    </mat-dialog-actions>
  </div>
</div>
